export default "<b-form-select\n  v-model=\"localeCode\"\n  :options=\"options\"\n  size=\"sm\"\n>\n</b-form-select>\n";